import { analytics } from '@moonpig/launchpad-analytics'
import { trackGAEvent } from './trackGAEvent'
import type { EventObject } from './schemaTypes'

let initialised = false

const launchpadAnalyticsTransport = (payload: Record<string, unknown>) => {
  trackGAEvent(payload as EventObject)
}

export const initialiseLaunchpadAnalytics = () => {
  if (initialised) return

  analytics.init({
    transport: launchpadAnalyticsTransport,
  })
  initialised = true
}
